module.exports = __webpack_public_path__ + "static/media/30x40.65c281e7.png";